import React from "react";
import { useMutation, useQuery } from "react-query";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import { Form, Input, Button, Select } from "antd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";

const ModalNewSupplier = ({ onClose, modalOpt, customSuppliers }) => {
  const [form] = Form.useForm();
  const {
    data: deliveryTimes,
    isLoading,
    error,
  } = useQuery("deliveryTimes", () =>
    Axios.get("/api/v1/delivery_times/").then((res) => res.data)
  );
  console.log(deliveryTimes, "deliveryTimes");
  const mutationPOST = useMutation({
    mutationFn: (value) =>
      Axios.post(`api/v1/suppliers/create_custom`, {
        supplier: {
          name: value.name,
          delivery_time: value.delivery_time,
          category: value.category,
          title: value.title,
        },
      }).then((res) => res.data),
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const mutationPUT = useMutation({
    mutationFn: (value) =>
      Axios.put(`api/v1/suppliers/${modalOpt.record_id}`, {
        supplier: {
          name: value.name,
          delivery_time: value.delivery_time,
          category: value.category,
          title: value.title,
        },
      }).then((res) => res.data),
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully updated", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  // Set form values when editing a supplier
  React.useEffect(() => {
    if (modalOpt.type === "edit_supplier") {
      const supplierToEdit = customSuppliers?.data?.find(
        (supplier) => supplier.id === modalOpt.record_id
      );
      if (supplierToEdit) {
        form.setFieldsValue({
          name: supplierToEdit?.name?.replace(/^c_u_s_/, ""),
          title: supplierToEdit?.title,
          category: supplierToEdit?.category,
          delivery_time: supplierToEdit?.delivery_time,
        });
      }
    }
  }, [modalOpt, form, customSuppliers]);

  return (
    <ModalSpecial
      style={{ width: 300 }}
      text={
        <span className="font-bold text-xl text-black">
          {modalOpt.type === "edit_supplier" ? "Edit" : "New"} Supplier
        </span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          if (modalOpt.type === "edit_supplier") {
            mutationPUT.mutate(values);
          } else {
            mutationPOST.mutate(values);
          }
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Supplier"
          name="name"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <Input addonBefore="c_u_s" placeholder="Type in" />
        </Form.Item>
        <Form.Item
          label="Supplier title"
          name="title"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <Input placeholder="Type in" />
        </Form.Item>
        <Form.Item
          label="Delivery time"
          name="delivery_time"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <Select
            showSearch
            placeholder="Select a delivery time"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            loading={isLoading}
          >
            {deliveryTimes?.data?.map((deliveryTime) => (
              <Select.Option key={deliveryTime.code} value={deliveryTime.code}>
                {deliveryTime.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={
              modalOpt.type === "edit_supplier"
                ? mutationPOST.isLoading
                : mutationPUT.isLoading
            }
          >
            {modalOpt.type === "edit_supplier" ? "Save" : "Add"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default ModalNewSupplier;
